import './LoadDraftView.css';

const LoadDraftView = ({
  savedDrafts,
  isLoadingDraft,
  currentLoadingDraft,
  onLoadDraft,
  onDeleteDraft,
  onBack
}) => {
  return (
    <div className="load-draft-view">
      <h2>Saved Drafts ({savedDrafts.length})</h2>
      <div className="saved-drafts-list">
        {savedDrafts.length === 0 ? (
          <p>No saved drafts found.</p>
        ) : (
          // Sort drafts by last_modified in descending order (newest first)
          savedDrafts
            .sort((a, b) => new Date(b.last_modified) - new Date(a.last_modified))
            .map((draft, index) => (
              <div key={index} className="saved-draft-item">
                <div
                  className="draft-info"
                  onClick={() => onLoadDraft(draft)}
                  style={{ cursor: isLoadingDraft ? 'wait' : 'pointer' }}
                >
                  <h3>
                    <span className="draft-number">{index + 1}.</span>
                    {draft.draft_name}
                    {isLoadingDraft && draft.draft_name === currentLoadingDraft && (
                      <span className="loading-indicator"> Loading...</span>
                    )}
                  </h3>
                  <p>Last Modified: {new Date(draft.last_modified).toLocaleString()}</p>
                  <p>Size: {Math.round(draft.size / 1024)} KB</p>
                </div>
                <button
                  className="delete-draft-button"
                  onClick={(e) => onDeleteDraft(draft, e)}
                  disabled={isLoadingDraft}
                >
                  Delete
                </button>
              </div>
            ))
        )}
      </div>
      <button className="cancel-button" onClick={onBack}>
        Back
      </button>
    </div>
  );
};

export default LoadDraftView;
